class AddAdmissionGroupAttributionSourceCtrl {
  constructor($scope, colorService, attributionSourceService, sdkUtils, organizationService, alertService) {
    //services
    this._$scope = $scope;
    this._colorService = colorService;
    this._attributionSourceService = attributionSourceService;
    this._sdkUtils = sdkUtils;
    this._organizationService = organizationService;
    this._alertService = alertService;
    this.attributionSource = this._$scope.attributionSource;
    this.editMode = !!this.attributionSource;
    this.searchTerm = '';
    this.loading = false;
    this.customer = this._$scope.customer;

    this.venue = $scope.venue;
    this.attributionSources = $scope.attributionSources;
    this.venueBrandColors = this.venue.branding ? {
      primaryColor: this.venue.branding.primaryColor ? colorService.rgbToHex(this.venue.branding.primaryColor.red, this.venue.branding.primaryColor.green, this.venue.branding.primaryColor.blue) : null
    } : {};
    this.createAttributionSourceForm = {};

    if (!this.venue) throw new Error('add-admission-group-attribution-source directive - venue is required on scope');
    if (!this.attributionSources) throw new Error('add-admission-group-attribution-source directive - attributionSources is required on scope');
  }

  enableNewAttributionSource($event) {
    if ($event) $event.preventDefault();

    this.createNewAttributionSource = true;
  }

  selectAttributionSource(attributionSource, $event) {
    if (!attributionSource) throw new Error('attributionSource');
    if ($event) $event.preventDefault();

    if (this._$scope.onAddedOrUpdated) {
      this._$scope.onAddedOrUpdated(attributionSource);
    }
  }

  removeAttributionSource($event) {
    if ($event) $event.preventDefault();

    delete this.attributionSource;
    this.createNewAttributionSource = false;
  }

  createAttributionSource(angularForm, $event) {
    if ($event) $event.preventDefault();

    this.submitted = true;

    if (!angularForm.$valid) return null;

    this.saving = true;

    const currentUserOrganization = this._organizationService.getCurrentOrganization();

    return this._attributionSourceService.createByOrganizationId(currentUserOrganization.id, {
        name: this.createAttributionSourceForm.name
      }).then(attributionSource => {
        this.attributionSource = attributionSource;
        this.saving = false;

        if (this._$scope.onAddedOrUpdated) {
          this._$scope.onAddedOrUpdated(attributionSource);
        }
      })
      .catch(response => {
        this.saving = false;
        this._alertService.error(this._sdkUtils.getErrorFromResponse(response));
      });
  }
}

AddAdmissionGroupAttributionSourceCtrl.$inject = [
  '$scope',
  'colorService',
  'jsSdk.attributionSource',
  'jsSdk.utils',
  'organizationService',
  'alertService'
];

export default AddAdmissionGroupAttributionSourceCtrl;



// WEBPACK FOOTER //
// ./src/directives/addAdmissionGroupAttributionSource/controller.js